<template>
    <!-- security  -->
    <main-page :title="title" :subtitle="subtitle" :description="description" :button-text="buttonText" :bg="bg" />
</template>

<script>
import MainPage from '@/views/components/MainPage.vue'
export default {
    name: 'security',
    components: {
        MainPage
    },
    data() {
        return {
            bg: "/img/pay/0--42.png",
        }
    },
    computed: {
        title() {
            return this.$t('security.title');
        },
        subtitle() {
            return this.$t('security.subtitle');
        },
        description() {
            return this.$t('security.description');
        },
        buttonText() {
            return this.$t('common.buttonText');
        }
    }
}
</script>